<template>
  <div id="acc_detail_right_reservation_last_minute">

    <div v-if="accommodation.reserve_whole_object">
      <div class="row">
        <div class="col-4">
          <figure class="pointer radius-07 m-0">
            <picture>
              <PartsSrcSetImage v-if="accommodation.hasImage(false)" :image="accommodation.getTopImage()"
                                :t_type="'thumbw'" :type="'webp'"/>
              <PartsSrcSetImage v-if="accommodation.hasImage(false)" :image="accommodation.getTopImage()"
                                :t_type="'thumbw'" :type="'jpeg'"/>

              <img v-if="accommodation.hasImage(false)" :src="accommodation.getTopImage().getTyrionSrc('thumbw')"
                   :alt="accommodation.title"
                   class="img-cover radius-07" loading="lazy"
                   :width="accommodation.getTopImage().seoWidth('thumb')"
                   :height="accommodation.getTopImage().seoHeight('thumb')">
              <img v-else src="~/assets/img/blank.jpg" :alt="accommodation.title"
                   class="img-cover radius-07" loading="lazy" width="600" height="337">
            </picture>
          </figure>
        </div>
        <div class="col-8">
          <p class="h5 mb-2">
            {{ accommodation.title }}
          </p>
          <p class="mb-0">
            {{ $t('date') }}: <b>{{ last_minute.date_from.day }}.{{
              last_minute.date_from.month
            }}</b>&nbsp;-&nbsp;<b>{{ last_minute.date_to.day }}.{{
              last_minute.date_to.month
            }}</b>
          </p>
          <template v-if="last_minute.curr_prices[currency] !== undefined">
            {{ $t('za-cenu') }}
            <strong>{{ Math.round(last_minute.curr_prices[currency] * last_minute.durationInDays() * 100) / 100 }}
              {{ currency }}</strong>/<small
              class="ms-1">{{
              $t('price-for-' + last_minute.price_for)
            }}</small>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-4">
          <figure class="pointer radius-07 m-0">
            <picture>
              <PartsSrcSetImage v-if="last_minute.unit.hasImage(false)" :image="last_minute.unit.getTopImage()"
                                :t_type="'thumbw'" :type="'webp'"/>
              <PartsSrcSetImage v-if="last_minute.unit.hasImage(false)" :image="last_minute.unit.getTopImage()"
                                :t_type="'thumbw'" :type="'jpeg'"/>

              <img v-if="last_minute.unit.hasImage(false)" :src="last_minute.unit.getTopImage().getTyrionSrc('thumbw')"
                   :alt="last_minute.unit.title"
                   class="img-cover radius-07" loading="lazy"
                   :width="last_minute.unit.getTopImage().seoWidth('thumb')"
                   :height="last_minute.unit.getTopImage().seoHeight('thumb')">
              <img v-else src="~/assets/img/blank.jpg" :alt="last_minute.unit.title"
                   class="img-cover radius-07" loading="lazy" width="600" height="337">
            </picture>
          </figure>
        </div>
        <div class="col-8">
          <p class="h6 mb-2">
            {{ accommodation.title }}
            <span class="d-block" v-if="!accommodation.reserve_whole_object && last_minute.unit">
              {{ last_minute.unit.title }}
            </span>
          </p>
          <p class="mb-0">
            {{ $t('date') }}: <b>{{ last_minute.date_from.day }}.{{
              last_minute.date_from.month
            }}</b>&nbsp;-&nbsp;<b>{{ last_minute.date_to.day }}.{{
              last_minute.date_to.month
            }}</b>
          </p>
          <template v-if="last_minute.curr_prices[currency] !== undefined">
            {{ $t('za-cenu') }}
            <strong>{{ Math.round(last_minute.curr_prices[currency] * last_minute.durationInDays() * 100) / 100 }}
              {{ currency }}</strong>/<small
              class="ms-1">{{ $t('price-for-' + last_minute.price_for) }}</small>
          </template>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12" v-if="isValidReservation !== true">
        <p class="text-danger">{{ isValidReservation }}</p>
      </div>
      <div class="col-12">
        <button class="btn btn-first btn-block btn-rounded" @click="generateReservation"
                :disabled="isValidReservation !== true">
          {{ $t('continue') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import {computed, PropType} from "vue";
import Accommodation from "../../../../../../lib/models/Accommodation";
import Client from "../../../../../../lib/models/Client";
import {useNuxtApp} from "#app";
import dayjs from "dayjs";

const {$i18n} = useNuxtApp();
const props = defineProps({
  accommodation: Object as PropType<Accommodation>,
  client: Object as PropType<Client>,
  currency: String,
  last_minute: Object,
  guests: Object,
});

const emit = defineEmits(['closeModal', 'reservationAction']);

const isValidReservation = computed(() => {
  const guestCount = Object.keys(props.guests).reduce((pValue, key) => {
    return pValue += (['adult', 'child', 'newborn'].indexOf(key) > -1 ? props.guests[key] : 0);
  }, 0);

  if (props.accommodation.reserve_whole_object && props.accommodation.max_hosts_capacity < guestCount) {
    return $i18n.t('maximum-number-of-guests-exceeded') + " " + props.accommodation.max_hosts_capacity;
  } else if (!props.accommodation.reserve_whole_object && props.last_minute.unit.getTotalNumberOfGuests() < guestCount) {
    return $i18n.t('maximum-number-of-guests-exceeded') + " " + props.last_minute.unit.getTotalNumberOfGuests();
  }

  return true;
});

const generateReservation = () => {
  emit('closeModal');
  emit('reservationAction', {
    id_units: [props.last_minute.unit.id],
    guests: props.guests,
    last_minute: props.last_minute,
    date: {
      from: dayjs().month(props.last_minute.date_from.month - 1).date(props.last_minute.date_from.day).format('YYYY-MM-DD'),
      to: dayjs().month(props.last_minute.date_to.month - 1).date(props.last_minute.date_to.day).format('YYYY-MM-DD')
    }
  });
}

</script>

